//
// Class representing an auction.
function ANFloorHelper(logger, floors, geo){

    // Constants.
    this.BIDDER_TYPE_ID_PREBID = 1;
    this.BIDDER_TYPE_ID_AMAZON = 2;
    this.CONTEXT_BIDSTREAM     = 'bidstream';
    this.CONTEXT_LOCAL         = 'local';

    this.__logger                     = logger || new AdsNinjaLogger();
    this.__geo                        = geo;
    this.__amazonAdElementIdOverrides = {};
    this.__selectedFloorsBidstream    = new Map();
    this.__selectedFloorsLocal        = new Map();
    this.__floorHisotry               = [];
    this.__bidstreamFloors            = (floors && typeof floors === 'object' && floors.hasOwnProperty(this.CONTEXT_BIDSTREAM)) ? floors.bidstream : [];
    this.__localFloors                = (floors && typeof floors === 'object' && floors.hasOwnProperty(this.CONTEXT_LOCAL)) ? floors.local : [];
    this.__feildsForBidstream         = ['geo', 'zoneName', 'parentZoneName', 'mediaType', 'size', 'bidderType'];
    this.__feildsForLocal             = ['geo', 'zoneName', 'parentZoneName', 'mediaType', 'size', 'bidderType', 'bidder'];
    this.__customKeySchemaForPrebid   = {
        fields: this.__feildsForBidstream,
    };

    // Create floor maps.
    this.__bidstreamFloorsForPrebid = {};
    this.__bidstreamFloorsMap       = new Map();

    this.__bidstreamFloors.forEach(function(floor){
        
        if(floor.geo && floor.geo.name !== this.__geo){

            return;
        }

        this.__bidstreamFloorsMap.set(floor.key, floor);

        if(!floor.bidderType || this.BIDDER_TYPE_ID_PREBID === floor.bidderType.id){

            this.__bidstreamFloorsForPrebid[floor.key] = floor.value;
        }
    }, this);

    // Create floor maps.
    this.__localFloorsMap = new Map();

    this.__localFloors.forEach(function(floor){
        
        if(floor.geo && floor.geo.name !== this.__geo){

            return;
        }

        this.__localFloorsMap.set(floor.key, floor);
    }, this);
}

//
// Returns bidstream floors.
ANFloorHelper.prototype.getBidstreamFloorsForPrebid = function(){
  
    return this.__bidstreamFloorsForPrebid;
};

//
// Returns custom key schema for Prebid.
ANFloorHelper.prototype.getCustomKeySchemaForPrebid = function(){
  
    return this.__customKeySchemaForPrebid;
};

//
// Returns additional schema field lookups attribute.
ANFloorHelper.prototype.constructAdditionalSchemaFieldLookupsAttributeForPrebid = function(){
  
    var self = this;

    return {
        geo: function(bidRequest, bidResponse){ return self.geoCallback(); }, 
        zoneName: function(bidRequest, bidResponse){ return self.zoneNameCallback(bidRequest); },
        parentZoneName: function(bidRequest, bidResponse){ return self.parentZoneNameCallback(bidRequest); },
        bidderType: function(bidRequest, bidResponse){ return self.bidderTypeCallback('prebid'); },
        bidder: function(bidRequest, bidResponse){ return self.bidderCallback('prebid'); },
    };
};

//
// Returns estimated geo of the user.
ANFloorHelper.prototype.geoCallback = function(){
    
    return this.__geo;
};

//
// Returns zone name.
ANFloorHelper.prototype.zoneNameCallback = function(details){
    
    if(!details){  

        return null;
    }

    var ad = this.__determineAdElement(details);

    if(!ad){
        
        this.__logger.warn('Unable to determine zone name.', {
            details: details,
        });
    
        return null;
    }

    return ad.zoneName;
};

//
// Returns parent zone name.
ANFloorHelper.prototype.parentZoneNameCallback = function(details){
    
    if(!details){  

        return null;
    }

    var ad = this.__determineAdElement(details);

    if(!ad){
        
        this.__logger.warn('Unable to determine parent zone name.', {
            details: details,
        });
    
        return null;
    }

    return ad.getParentZoneName();
}

//
// Returns media type.
ANFloorHelper.prototype.mediaTypeCallback = function(details){
    
    if(!details){  

        return null;
    }

    var mediaType = details.mediaType;

    if('d' === mediaType){

        mediaType = 'banner';
    }

    return mediaType || null;
};

//
// Returns size.
ANFloorHelper.prototype.sizeCallback = function(details){
    
    if(!details){  

        return null;
    }

    if(details.hasOwnProperty('adsNinja')){

        return details.adsNinja.size || null;
    }

    return details.size || null;
};

//
// Returns bidder type.
ANFloorHelper.prototype.bidderTypeCallback = function(biddingLibrary){
    
    if(!biddingLibrary){  

        return null;
    }

    switch(biddingLibrary){

        default:

            return biddingLibrary.charAt(0).toUpperCase() + biddingLibrary.slice(1);
    }
};

//
// Returns bidder.
ANFloorHelper.prototype.bidderCallback = function(details){
    
    if(!details){

        return null;
    }

    return details.bidderCode || null;
}

//
// Determine ad emelent ID.
ANFloorHelper.prototype.__determineAdElementId = function(details){
    
    if(!details){  

        return null;
    }

    // if(details.hasOwnProperty('adsNinja')){

    //     return details.adsNinja.adElementId || null;
    // }

    var amazonAdElementId = details.slotID || null;

    // Amazon mapping of zones.
    if(amazonAdElementId){
        
        if(this.__amazonAdElementIdOverrides.hasOwnProperty(amazonAdElementId)){
            
            var map              = this.__amazonAdElementIdOverrides[amazonAdElementId] || {};
            var objectKeysLength = Object.keys(map).length;

            if(1 === objectKeysLength){

                amazonAdElementId = map[Object.keys(map)[0]];
            }
            else if(objectKeysLength > 1){

                this.__logger.warn('Unable to determine ad element ID.', {
                    amazonAdElementId: amazonAdElementId,
                    map: map,
                });

                amazonAdElementId = map[Object.keys(map)[0]];
            }            
        }

        return amazonAdElementId;
    }

    // if(details.hasOwnProperty('adsNinja')){

    //     return details.adsNinja.adElementId || null;
    // }

    var prebidAdElementId = details.adUnitCodeGAMRequest || details.adUnitCode;
    var adElementId       = details.adElementId || null;

    return prebidAdElementId || adElementId;
};

//
// Returns ad element.
ANFloorHelper.prototype.__determineAdElement = function(details){

    if(!details){  

        return null;
    }

    var adElementId = this.__determineAdElementId(details);

    if(!adElementId){

        return null;
    }

    // TODO: Use zoneManager in the future.
    return window.adsNinjaHeaderBiddingManager.getAdsData(adElementId);
};

//
// Enumerates possible feild values.
ANFloorHelper.prototype.enumerateFeildValues = function(floorFields, biddingLibrary, details){
    
    if(0 === floorFields.length){

        return [];
    };

    // Floor field types with their matching functions to resolve the actual matched value.
    var self                   = this;
    var fieldMatchingFunctions = {
        'geo': function(details){ return self.geoCallback() || '*' }, 
        'zoneName': function(details){ return self.zoneNameCallback(details) || '*' }, 
        'parentZoneName': function(details){ return self.parentZoneNameCallback(details) || '*' },
        'mediaType': function(details){ return self.mediaTypeCallback(details) || 'banner' }, 
        'size': function(details){ return self.sizeCallback(details) || '*' }, 
        'bidderType': function(details){ return self.bidderTypeCallback(biddingLibrary) || '*' },
        'bidder': function(details){ return self.bidderCallback(details) || '*' },
    };

    // Generate combination of all exact matches and catch all for each field type.
    return floorFields.reduce(function(accumulator, field){

        var exactMatch = fieldMatchingFunctions[field](details) || '*';

        accumulator.push((exactMatch === '*') ? ['*'] : [exactMatch, '*']);

        return accumulator;
    }, []);
};

//
// Enumerates possible floors.
ANFloorHelper.prototype.enumeratePossibleFloors = function(feildValues, delimiter){

    return feildValues.reduce(function(accumulator, currentValue){

        var returnValue = [];

        accumulator.map(function(value1){

            return currentValue.map(function(value2){

                return returnValue.push(value1 + delimiter + value2);
            });
        });
        
        return returnValue;
    }).sort(function(left, right){ 

        return (left.split('*').length - right.split('*').length);
    });
};

//
// Gets bids above local floors.
ANFloorHelper.prototype.getBidsAboveLocalFloors = function(biddingLibrary, bids){

    return this.__getBidsAboveFloors(this.CONTEXT_LOCAL, biddingLibrary, bids);
};

//
// Gets bids above bidstream floors.
ANFloorHelper.prototype.getBidsAboveBidstreamFloors = function(biddingLibrary, bids){

    return this.__getBidsAboveFloors(this.CONTEXT_BIDSTREAM, biddingLibrary, bids);
};

//
// Gets bids above floors.
ANFloorHelper.prototype.getBidsAboveFloors = function(biddingLibrary, bids){

    return this.__getBidsAboveFloors(this.CONTEXT_LOCAL, biddingLibrary, this.__getBidsAboveFloors(this.CONTEXT_BIDSTREAM, biddingLibrary, bids));
};

//
// Gets bids above floors.
ANFloorHelper.prototype.__getBidsAboveFloors = function(context, biddingLibrary, bids){
    
    var contextData = this.__getContextData(context);

    if(!contextData || typeof contextData !== 'object' || Object.keys(contextData).length === 0){

        return [];    
    }

    var returnResult = [];

    // Loop through all bids and check if they are above floor.
    for(var i = 0; i < bids.length; i++){
        
        var isAboveFloor = this.__isBidAboveFloors(context, biddingLibrary, bids[i], contextData.map, contextData.feilds);

        if(isAboveFloor){

            returnResult.push(bids[i]);
        }
    }

    return returnResult;
};

//
// Is bid above local floors.
ANFloorHelper.prototype.isBidAboveLocalFloors = function(biddingLibrary, bid){ 
    
    var context     = this.CONTEXT_LOCAL;
    var contextData = this.__getContextData(context);

    if(!contextData || typeof contextData !== 'object' || Object.keys(contextData).length === 0){

        return false;    
    }

    return this.__isBidAboveFloors(context, biddingLibrary, bid, contextData.map, contextData.feilds);
};

//
// Is bid above bidstream floors.
ANFloorHelper.prototype.isBidAboveBidstreamFloors = function(biddingLibrary, bid){
    
    var context     = this.CONTEXT_BIDSTREAM;
    var contextData = this.__getContextData(context);

    if(!contextData || typeof contextData !== 'object' || Object.keys(contextData).length === 0){

        return false;    
    }

    return this.__isBidAboveFloors(context, biddingLibrary, bid, contextData.map, contextData.feilds);
};

//
// Is bid above floors.
ANFloorHelper.prototype.isBidAboveFloors = function(biddingLibrary, bid){

    return (this.isBidAboveBidstreamFloors(biddingLibrary, bid) && this.isBidAboveLocalFloors(biddingLibrary, bid));
};

//
// Returns bid above floors.
ANFloorHelper.prototype.__isBidAboveFloors = function(context, biddingLibrary, bid, map, feilds){
    
    var feildValues    = this.enumerateFeildValues(feilds, biddingLibrary, bid);
    var possibleFloors = this.enumeratePossibleFloors(feildValues, '|');
    var adElementId    = this.__determineAdElementId(bid);

    for(var i = 0; i < possibleFloors.length; i++){
        
        if(!map.has(possibleFloors[i])){

            continue;
        }

        var possibleFloor = map.get(possibleFloors[i]);
            
        this.__addFloorToHistory(context, biddingLibrary, adElementId, bid, possibleFloor);

        return (bid.cpm >= possibleFloor.value);
    }

    return true;
};

//
// Returns first matching floor.
ANFloorHelper.prototype.getFirstMatchingFloor = function(context, biddingLibrary, slot){

    var contextData = this.__getContextData(context);

    if(!contextData || typeof contextData !== 'object' || Object.keys(contextData).length === 0){

        return null;    
    }

    var adElementId = this.__determineAdElementId(slot);
    var key         = this.__getPreviouslySelectedFloorKey(adElementId, biddingLibrary);

    if(contextData.previouslySelectedFloors.has(key)){
        
        // Previously selected floor.
        return contextData.previouslySelectedFloors.get(key);
    }

    var chosenFloor = null;

    if('amazon' === biddingLibrary){

        // Adapt slot to needed format.
        var potentialSlots = [];

        for(var i = 0; i < slot.sizes.length; i++){
            
            var size           = slot.sizes[i];
            slot.adsNinja      = slot.adsNinja || {};
            slot.adsNinja.size = size.join('x');

            potentialSlots.push(slot);
        }

        for(var i = 0; i < potentialSlots.length; i++){
            
            var result = this.__getFirstMatchingFloor(biddingLibrary, contextData.map, contextData.feilds, potentialSlots[i]);

            if(result && (!chosenFloor || result.value > chosenFloor.value)){
                
                chosenFloor = result;
            }
        }
    }
    else{

        chosenFloor = this.__getFirstMatchingFloor(biddingLibrary, contextData.map, contextData.feilds, slot);
    }

    this.__addFloorToDictionaryAndHistory(context, biddingLibrary, adElementId, slot, chosenFloor);

    return chosenFloor;
};

//
// Returns first matching floor.
ANFloorHelper.prototype.__getFirstMatchingFloor = function(biddingLibrary, map, feilds, slot){
  
    var feildValues    = this.enumerateFeildValues(feilds, biddingLibrary, slot);
    var possibleFloors = this.enumeratePossibleFloors(feildValues, '|');

    for(var i = 0; i < possibleFloors.length; i++){
        
        if(map.has(possibleFloors[i])){
            
            return map.get(possibleFloors[i]);
        }
    }

    return null;
};

//
// Add Amazon ad element id override.
ANFloorHelper.prototype.addAmazonAdElementIdOverride = function(adElementId, amazonAdElementId){
  
    if(!adElementId || !amazonAdElementId){

        return;
    }

    if(!this.__amazonAdElementIdOverrides.hasOwnProperty(amazonAdElementId)){
        
        this.__amazonAdElementIdOverrides[amazonAdElementId] = {};
    }

    this.__amazonAdElementIdOverrides[amazonAdElementId][adElementId] = adElementId;
};

//
// Add floor to dictionary.
ANFloorHelper.prototype.__addFloorToDictionaryAndHistory = function(context, biddingLibrary, adElementId, details, floor){
    
    var key = this.__getPreviouslySelectedFloorKey(adElementId, biddingLibrary);

    switch(context){
        
        case this.CONTEXT_BIDSTREAM:
            
            this.__selectedFloorsBidstream.set(key, floor);
            
            break;
        
        case this.CONTEXT_LOCAL:
            
            this.__selectedFloorsLocal.set(key, floor);
            
            break;

        default:

            this.log('Unable to add floor to dictionary!', {
                context: context,
                biddingLibrary: biddingLibrary,
                adElementId: adElementId,
                details: details,
                floor: floor,
            });

            break;
    }

    this.__addFloorToHistory(context, biddingLibrary, adElementId, details, floor);
};

//
// Add floor to history.
ANFloorHelper.prototype.__addFloorToHistory = function(context, biddingLibrary, adElementId, details, floor){
  
    this.__floorHisotry.push({
        context: context,
        biddingLibrary: biddingLibrary,
        adElementId: adElementId,
        details: details,
        floor: floor,
    });
};

//
// Returns key for previously selected floor map.
ANFloorHelper.prototype.__getPreviouslySelectedFloorKey = function(adElementId, biddingLibrary){
  
    return `${adElementId}-${biddingLibrary}`;
};

//
// Returns context data.
ANFloorHelper.prototype.__getContextData = function(context){

    switch(context){

        case this.CONTEXT_BIDSTREAM:

            return {
                map:                      this.__bidstreamFloorsMap,
                feilds:                   this.__feildsForBidstream,
                previouslySelectedFloors: this.__selectedFloorsBidstream,
            };

        case this.CONTEXT_LOCAL:

            return {
                map:                      this.__localFloorsMap,
                feilds:                   this.__feildsForLocal,
                previouslySelectedFloors: this.__selectedFloorsLocal,
            };

        default:

            return null;
    }
};

window.ANFloorHelper = ANFloorHelper;